import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import {client} from '../client';
import { feedByFilterAndSortQuery, feedBySortQuery, searchByCategoryAndSortQuery, searchByCategoryAndFilterAndSortQuery } from '../utils/data';
//import MasonryLayout from './MasonryLayout';
import Masonic from './Masonic';
import Spinner from './Spinner';

import NoMatchFound from '../assets/NoMatchFound.png';

const Feed = ({filter,sort}) => {
  const [loading, setLoading] = useState(false);
  const [prompts, setPrompts] = useState(null);
  const { categoryId } = useParams();

  useEffect(() => {
    setLoading(true);

  if(categoryId) {
      // const query = searchByCategoryQuery(categoryId)

      // client.fetch(query)
      //   .then((data) => {
      //       setPrompts(data);
      //       setLoading(false);
      //   })


        if(filter != 'All') {
          const query = searchByCategoryAndFilterAndSortQuery(categoryId, filter, sort)
   
           client.fetch(query)
         .then((data) => {
           setPrompts(data);
           setLoading(false);
         })
   
         } else {
           const query = searchByCategoryAndSortQuery(categoryId, sort)
   
           client.fetch(query)
         .then((data) => {
           setPrompts(data);
           setLoading(false);
         })
         
         }

    } else {

      if(filter != 'All') {
       const query = feedByFilterAndSortQuery(filter, sort)

        client.fetch(query)
      .then((data) => {
        setPrompts(data);
        setLoading(false);
      })

      } else {
        const query = feedBySortQuery(sort)

        client.fetch(query)
      .then((data) => {
        setPrompts(data);
        setLoading(false);
      })
      
      }

      
    }
  }, [categoryId, sort, filter])
  
  
  if(loading) return <Spinner message='Searching...' />

  if(!prompts?.length) return (
    <div className='flex flex-col justify-center items-center top-0 right-0 left-0 bottom-0'>
      <img src={NoMatchFound} className='w-9/10' alt='logo' />
      <p className='mt-5'>Uh-Oh!</p>
      <p>We are not able to find any results...</p>
    </div>
  ) 

  return (
    <div>
      {/* {prompts?.length > 0 && <MasonryLayout prompts={prompts} />} */}
      {prompts && <Masonic prompts={prompts} />}
    </div>
  )
}



export default Feed